<template>
  <div id="data-list-list-view" class="data-list-container">
    <add
      :isSidebarActive="addPrompt"
      @closePrompt="toggleAddPrompt"
      :callBackFunction="callBackAdd"
    />
    <update
      :isSidebarActive="updatePrompt"
      @closeUpdate="toggleUpdatePrompt"
      :callBackFunction="getFolders"
      :model="model"
    />
    <vs-table ref="table" :max-items="10" :data="folders">
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div
          class="flex flex-wrap-reverse items-center data-list-btn-container"
        >
          <div
            @click="addPrompt = true"
            class="
              btn-add-new
              p-3
              mb-4
              mr-4
              rounded-lg
              cursor-pointer
              flex
              items-center
              justify-center
              text-lg
              font-medium
              text-base text-primary
              border border-solid border-primary
            "
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Ajouter</span>
          </div>
          <div
            @click="getFolders(1)"
            class="
              btn-add-new
              p-3
              mb-4
              mr-4
              rounded-lg
              cursor-pointer
              flex
              items-center
              justify-center
              text-lg
              font-medium
              text-base text-primary
              border border-solid border-primary
            "
          >
            <feather-icon icon="RefreshCwIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Actualiser</span>
          </div>
        </div>
        <div class="con-input-search vs-table--search">
          <input
            v-model="stringSearch"
            @keypress.enter="findFolders()"
            type="text"
            class="input-search vs-table--search-input"
          />
          <i class="vs-icon notranslate icon-scale material-icons null"
            >search</i
          >
        </div>
      </div>

      <template slot="thead">
        <vs-th>Dossier</vs-th>
        <vs-th>Nombres de requêtes</vs-th>
        <vs-th>Planifier pour</vs-th>
        <vs-th>Crée le</vs-th>
        <vs-th>Utilisateur</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td width="40%">
              <span class="">{{ tr.name }} </span>
            </vs-td>

            <vs-td width="10%">
              <span class="">{{ tr.nbr_request }} </span>
            </vs-td>

            <vs-td width="10%">
              <span class="">{{ tr.planned_date }} </span>
            </vs-td>

            <vs-td width="20%">
              <p class="product-category">{{ tr.created_at }}</p>
            </vs-td>

            <vs-td width="20%">
              <p class="product-price">{{ tr.user ? tr.user.name : "" }}</p>
            </vs-td>

            <vs-td width="20%" class="whitespace-no-wrap">
              <div class="flex">
                <div
                  class="flex"
                  @click="
                    $router.push({
                      name: 'folders_details',
                      params: { id: tr.id },
                    })
                  "
                >
                  <feather-icon
                    icon="EyeIcon"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                    class="mr-2"
                  />
                </div>

                <div class="flex" @click="alter(tr)">
                  <feather-icon
                    icon="EditIcon"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                    class="mr-2"
                  />
                </div>

                <div class="flex" @click="removeFolder(tr)">
                  <feather-icon
                    icon="DeleteIcon"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                    class="mr-2"
                  />
                </div>
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <vs-pagination
      v-if="last_page && page"
      :total="last_page"
      v-model="page"
    ></vs-pagination>
  </div>
</template>

<script>
import { _buildQuery } from "../../helpers/helper";
import Add from "./add";
import Update from "./update";
export default {
  name: "folder",
  components: { Update, Add },
  data: () => ({
    page: 1,
    last_page: 1,
    folders: [],
    addPrompt: false,
    updatePrompt: false,
    model: {},
    stringSearch: "",
  }),
  watch: {
    page(value) {
      if (this.stringSearch) {
        this.findFolders(value);
      } else this.getFolders(value);
    },
  },
  methods: {
    async findFolders(page = null) {
      if (this.stringSearch) {
        try {
          this.$vs.loading();
          let params = {
            page: page ? page : 1,
            search: this.stringSearch,
          };
          let response = await this.$http.get("/folders" + _buildQuery(params));
          if (response) {
            this.folders = response.data.data;
            this.last_page = response.data.last_page;
          }
          this.$vs.loading.close();
        } catch (error) {
          this.$vs.loading.close();
          this.$vs.notify({
            time: 5000,
            title: "Échec!",
            text: "Veuillez rééessayer ou contacter l'administrateur",
            color: "danger",
            iconPack: "feather",
            position: "top-right",
            icon: "icon-x-circle",
          });
        }
      } else this.getFolders(1);
    },
    toggleAddPrompt(val = false) {
      this.addPrompt = val;
    },
    toggleUpdatePrompt(val = false) {
      this.updatePrompt = val;
    },
    alter(model) {
      this.model = model;
      this.updatePrompt = true;
    },
    getFolders(page) {
      this.$vs.loading();
      this.$http
        .get("/folders?page=" + page)
        .then((response) => {
          this.folders = response.data.data;
          this.last_page = response.data.last_page;
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);
        });
    },
    removeFolder(tr) {
      if (confirm("Voulez vous supprimer ce dossier ?")) {
        this.$vs.loading();
        this.$http
          .post("/folders/delete", {
            id: tr.id,
            date: tr.planned_date,
          })
          .then((response) => {
            let index = this.folders.indexOf(tr);
            this.folders.splice(index, 1);
            this.$vs.loading.close();
          })
          .catch((error) => {
            this.$vs.loading.close();
            console.log(error);
          });
      }
    },
    callBackAdd(data) {
      this.folders.unshift(data.model);
    },
  },
  mounted() {
    this.getFolders(this.page);
  },
};
</script>

<style scoped>
</style>
